import React, { useMemo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import './bulk-update-banner.css';

const buildBannerText = (progress) => {
    if (!progress) {
        return 'Выполняется применение настроек модемов, можно продолжать работу';
    }

    const total = Number(progress.total) || 0;
    const completed = Number(progress.completed) || 0;
    const errors = Number(progress.errors) || 0;

    if (progress.message) {
        return progress.message;
    }

    if (progress.phase === 'preparing') {
        return total > 0
            ? `Подготовка применения настроек к ${total} модемам…`
            : 'Подготовка применения настроек модемов…';
    }

    if (total > 0) {
        const errSuffix = errors > 0 ? `, ошибок: ${errors}` : '';
        return `Передача настроек в Kraken: ${completed} из ${total}${errSuffix}`;
    }

    return 'Выполняется передача настроек модемов в Kraken…';
};

/**
 * Информер при массовом обновлении модемов: спиннер, текст, прогресс.
 */
const BulkUpdateBanner = ({ visible, progress = null, onClose }) => {
    const text = useMemo(() => buildBannerText(progress), [progress]);

    const total = Number(progress?.total) || 0;
    const completed = Number(progress?.completed) || 0;
    const percent = total > 0 ? Math.min(100, Math.round((completed / total) * 100)) : null;

    if (!visible) return null;

    return (
        <div
            className="bub bub--success"
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label={text}
        >
            <span className="bub__spinner" aria-hidden="true">
                <LoadingOutlined spin />
            </span>
            <div className="bub__body">
                <span className="bub__text">{text}</span>
                {percent !== null ? (
                    <div
                        className="bub__progress"
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={100}
                        aria-valuenow={percent}
                        aria-label={`Выполнено ${percent} процентов`}
                    >
                        <div className="bub__progress-fill" style={{ width: `${percent}%` }} />
                    </div>
                ) : null}
            </div>
            <button
                type="button"
                className="bub__close"
                onClick={onClose}
                aria-label="Скрыть информер (обновление продолжится в фоне)"
                tabIndex={0}
            >
                ×
            </button>
        </div>
    );
};

export default BulkUpdateBanner;
